import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchVotes = () => {
  const [votes, setVotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getAccessTokenSilently } = useAuth0();
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchVotesData = async () => {
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_API_AUDIENCE,
          }
        });
        const response = await fetch(`${apiUrl}/api/votes`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        if (response.ok) {
          const data = await response.json();
          setVotes(data);
          setLoading(false);
        } else {
          console.error('Failed to fetch votes:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching votes:', error.message);
      }
    };
    fetchVotesData();
  }, [getAccessTokenSilently, apiUrl]);

  return { votes, loading };
};
